// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder_placeholder__G4ohv","text":"Placeholder_text__ZKEJD","title":"Placeholder_title__Tc3OQ","description":"Placeholder_description__0xGje"};